import { InsertionIdentification } from '../../../../../../@types/types'
import { RealEstateState } from '../../../../../../services/domain/status'

export const metaInformationToApi = (ident: InsertionIdentification) => ({
  selectedMenuItem: ident.metaInformation?.selectedMenuItem ?? 'contactDataSection',
  entryMode: ident.metaInformation?.entryMode ?? RealEstateState.NEW_INSERTION,
})
